import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { XdrSearchLiveController } from '../controller/XdrSearchLiveController';

export class XdrSearchLiveWebComponent extends BaseWebComponentElement {
  public controller: XdrSearchLiveController | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: XdrSearchLiveController,
    });
  }
}
